:host {
  display: block;
  max-width: 100%;
}

div#main-slider-list {
  align-items: center;
}

.slider.visible {
  visibility: visible;
}